
import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

const AdminLoadingSkeleton = () => {
  return (
    <div className="container mx-auto p-4 space-y-8">
      <Skeleton className="h-12 w-full max-w-md mb-8" />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-32 w-full" />
      </div>
      <Skeleton className="h-96 w-full" />
    </div>
  );
};

export default AdminLoadingSkeleton;
